import "./index.scss";

interface IProps {
  color?: string;
}
export const ValidateErrorIcon = ({color = '#891818' }: IProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C10.4241 24 8.8637 23.6896 7.4078 23.0866C5.95189 22.4835 4.62902 21.5996 3.51472 20.4853C2.40041 19.371 1.5165 18.0481 0.913444 16.5922C0.310388 15.1363 -7.09137e-07 13.5759 0 12C-7.09137e-07 10.4241 0.310388 8.8637 0.913444 7.4078C1.5165 5.95189 2.40041 4.62902 3.51472 3.51472C4.62902 2.40041 5.95189 1.5165 7.4078 0.913444C8.8637 0.310388 10.4241 -7.09137e-07 12 0C13.5759 -7.09137e-07 15.1363 0.310388 16.5922 0.913444C18.0481 1.5165 19.371 2.40041 20.4853 3.51472C21.5996 4.62902 22.4835 5.95189 23.0866 7.4078C23.6896 8.8637 24 10.4241 24 12C24 13.5759 23.6896 15.1363 23.0866 16.5922C22.4835 18.0481 21.5996 19.371 20.4853 20.4853C19.371 21.5996 18.0481 22.4835 16.5922 23.0866C15.1363 23.6896 13.5759 24 12 24ZM11.701 18.75C12.0989 18.75 12.4804 18.5919 12.7617 18.3106C13.043 18.0293 13.201 17.6478 13.201 17.25C13.201 17.053 13.1622 16.858 13.0869 16.676C13.0115 16.494 12.901 16.3286 12.7617 16.1893C12.6224 16.0501 12.457 15.9396 12.2751 15.8642C12.0931 15.7888 11.898 15.75 11.701 15.75C11.504 15.75 11.309 15.7888 11.127 15.8642C10.945 15.9396 10.7797 16.0501 10.6404 16.1893C10.5011 16.3286 10.3906 16.494 10.3152 16.676C10.2398 16.858 10.201 17.053 10.201 17.25C10.201 17.6478 10.3591 18.0293 10.6404 18.3106C10.9217 18.5919 11.3032 18.75 11.701 18.75ZM11.5399 14.25H11.8594C12.3936 14.25 12.8262 13.8203 12.8262 13.2862V6.21388C12.8262 5.67964 12.3936 5.25004 11.8594 5.25004H11.5399C11.0057 5.25004 10.576 5.67964 10.576 6.21388V13.2862C10.576 13.8204 11.0057 14.25 11.5399 14.25Z"
        fill={color}
      />
    </svg>
  );
};
